import React from "react";
// import bgHero from "../../images/header/herobgimg.png";
import bgHero from "../../images/header/herobgwebp.webp";

import { Navigate, useLocation } from "react-router-dom";
import sideArrow from "../../images/icons/sideArrow.png";
import NavBar from "./NavBar";
import { Fade } from "react-awesome-reveal";
const HeroSection = () => {
  // const toggleMenu = () => setMenuOpen(!menuOpen);
  const location = useLocation();

  const moveToSection = (id) => {
    if (location.pathname !== "/") {
      // Go to home page *with state*
      Navigate("/", { state: { scrollTo: id } });
    } else {
      // Already on home → scroll immediately
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  return (
    <section
      id="home"
      className="bg-image  max-w-8xl relative md:px-[120px] px-4 md:bg-no-repeat bg-cover   md:bg-cover text-white top-0"
      style={{
        backgroundImage: `url(${bgHero})`,
      }}
    >
      {/* Overlay */}
      {/* <div className="absolute inset-0 bg-black/20"></div> */}

      {/* Navbar */}
      <NavBar />

      {/* Hero Content */}
      <Fade delay={1e2} cascade damping={1e-1}>
        <div
          className="relative z-10 flex flex-col justify-center  text-left"
          style={{ minHeight: "75vh" }}
        >
          {" "}
          {/* custom responsive height */}
          <div className="max-w-8xl md:mb-[222px] lg:mt-6">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold  leading-[38px] md:leading-[48px] lg:leading-[80px] mb-4">
              Corporate Car Rental &<br />
              Tour Travel Solution for
              <br />
              IT Companies
            </h1>
            <button
              onClick={() => moveToSection("services")}
              className="mt-4 md:text-[16px] md:w-[152px] md:h-[48px] bg-black  text-white font-semibold py-3   flex items-center   rounded-md transition duration-300"
            >
              <span className="mx-1 md:mx-2">Know more</span>
              <span className=" lg:px-2 w-7 h-7 md:w-[30px] md:h-[30px] flex items-center justify-center bg-white rounded-full">
                <img
                  src={sideArrow}
                  className="w-3 h-3 rotate-180 object-contain"
                  alt="arrow"
                />
              </span>
            </button>
          </div>
        </div>
      </Fade>

      {/* Overlapping Box */}

      <div className="max-w-8xl bg-[#FFF2E1] absolute   h-36   md:h-[182px] left-1/2 transform -translate-x-1/2 bottom-[-5rem] md:bottom-[-5rem] z-20 w-[90%] md:w-10/12 text-gray-800 shadow-xl rounded-2xl">
        <Fade direction="up" triggerOnce ascade damping={0.2}>
          <h2 className="text-xl md:text-4xl mt-8 font-bold  md:mt-[36px] md:h-[62px]  md:text-center text-center">
            For All Your Mobility Needs
          </h2>
          <div className="text-center mt-4">
            <ul className="flex justify-center items-center h-[32px] text-sm md:text-[20px] gap-2 md:gap-[31px]">
              <li className="relative pl-4 before:content-[''] before:w-2 before:h-2 before:bg-[#CCA065] before:rounded-full before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2">
                Business
              </li>

              <li className="relative pl-4 before:content-[''] before:w-2 before:h-2 before:bg-[#CCA065] before:rounded-full before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2">
                Leisure
              </li>

              <li className="relative pl-4 before:content-[''] before:w-2 before:h-2 before:bg-[#CCA065] before:rounded-full before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2">
                Corporate
              </li>
            </ul>
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default HeroSection;
